import { BlockTitle } from "@/shared/Components";
import type { FC } from "react";
import type { DataListProps } from "./types";
import { List } from "./Components/List";
import styles from "./styles.module.scss";

export const DataList: FC<DataListProps> = ({
  title,
  onAddClick,
  data,
  editNode,
  onTrashClick = () => "",
  isEdit = false,
  disabled = false,
  hint,
}) => {
  return (
    <div className={styles.root}>
      <BlockTitle title={title} onClick={onAddClick} disabled={disabled} hint={hint} />
      <div className={styles.body} data-editing={isEdit}>
        <List data={data} editNode={editNode} isEdit={isEdit} onTrashClick={onTrashClick} />
      </div>
    </div>
  );
};
